import { createFileRoute } from '@tanstack/react-router'
import { ValueStoryEdit } from 'pages/valueStories/ValueStoryEdit'

export const Route = createFileRoute(
  '/value-stories/$siteID/$valueStoryID/edit'
)({
  component: ValueStoryEdit,
  staticData: {
    title: 'Edit Value Story',
    layout: {
      enableScrolling: true,
      showNavbar: true,
    },
  },
})
